function clamp(value, min, max) {
  return Math.max(min, Math.min(max, value));
}

export function computeFourSlotRegions(boardArea, options = {}) {
  const x = Number.isFinite(boardArea?.x) ? boardArea.x : 0;
  const y = Number.isFinite(boardArea?.y) ? boardArea.y : 0;
  const w = Math.max(0, Number.isFinite(boardArea?.w) ? boardArea.w : 0);
  const h = Math.max(0, Number.isFinite(boardArea?.h) ? boardArea.h : 0);

  const paddingRatioX = clamp(options.paddingRatioX ?? options.paddingRatio ?? 0.04, 0, 0.2);
  const paddingRatioY = clamp(options.paddingRatioY ?? options.paddingRatio ?? 0.04, 0, 0.2);
  const gutterRatioX = clamp(options.gutterRatioX ?? options.gutterRatio ?? 0.03, 0, 0.2);
  const gutterRatioY = clamp(options.gutterRatioY ?? options.gutterRatio ?? 0.03, 0, 0.2);

  const paddingX = w * paddingRatioX;
  const paddingY = h * paddingRatioY;
  const gutterX = w * gutterRatioX;
  const gutterY = h * gutterRatioY;

  const innerW = Math.max(0, w - paddingX * 2 - gutterX);
  const innerH = Math.max(0, h - paddingY * 2 - gutterY);
  const slotW = innerW / 2;
  const slotH = innerH / 2;

  const leftX = x + paddingX;
  const rightX = leftX + slotW + gutterX;
  const topY = y + paddingY;
  const bottomY = topY + slotH + gutterY;

  return [
    { x: leftX, y: topY, w: slotW, h: slotH },
    { x: rightX, y: topY, w: slotW, h: slotH },
    { x: leftX, y: bottomY, w: slotW, h: slotH },
    { x: rightX, y: bottomY, w: slotW, h: slotH },
  ];
}

export function computeSequentialLeftAlignedRegions(boardArea, childCount, options = {}) {
  const x = Number.isFinite(boardArea?.x) ? boardArea.x : 0;
  const y = Number.isFinite(boardArea?.y) ? boardArea.y : 0;
  const w = Math.max(0, Number.isFinite(boardArea?.w) ? boardArea.w : 0);
  const h = Math.max(0, Number.isFinite(boardArea?.h) ? boardArea.h : 0);
  const count = Math.max(0, Math.min(4, Number.isFinite(childCount) ? childCount : 0));
  if (count === 0) return [];

  const paddingRatioX = clamp(options.paddingRatioX ?? options.paddingRatio ?? 0.04, 0, 0.2);
  const paddingRatioY = clamp(options.paddingRatioY ?? options.paddingRatio ?? 0.08, 0, 0.3);
  const gutterRatioY = clamp(options.gutterRatioY ?? options.gutterRatio ?? 0.025, 0, 0.2);

  const paddingX = w * paddingRatioX;
  const paddingY = h * paddingRatioY;
  const gutterY = h * gutterRatioY;

  const usableH = Math.max(0, h - paddingY * 2 - gutterY * Math.max(0, count - 1));
  const slotW = Math.max(0, w - paddingX * 2);
  const slotH = usableH / count;

  const rects = [];
  const leftX = x + paddingX;
  let cy = y + paddingY;
  for (let i = 0; i < count; i++) {
    rects.push({ x: leftX, y: cy, w: slotW, h: slotH });
    cy += slotH + gutterY;
  }

  return rects;
}
